import { render, staticRenderFns } from "./CheckoutSummary.vue?vue&type=template&id=d1c671b2&scoped=true"
import script from "./CheckoutSummary.vue?vue&type=script&lang=js"
export * from "./CheckoutSummary.vue?vue&type=script&lang=js"
import style0 from "./CheckoutSummary.vue?vue&type=style&index=0&id=d1c671b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c671b2",
  null
  
)

export default component.exports